import React from 'react';
import Header from './Header';
import Player from './Player';
import AddPlayerForm from './AddPlayerForm';

class App extends React.Component {
  state = {
    players: [
      {
        name: "Jason",
        score: 0,
        id: 1,
        isHighScore: false
      },
      {
        name: "Jennifer",
        score: 0,
        id: 2,
        isHighScore: false
      },
      {
        name: "Evan",
        score: 0,
        id: 3,
        isHighScore: false
      },
      {
        name: "Leeloo",
        score: 0,
        id: 4,
        isHighScore: false
      }
    ]
  };

  // Previous Player ID Counter
  prevPlayerID = 4;

  handleScoreChange = (index, delta) => {
    this.setState( prevState => ({
      score: prevState.players[index].score += delta
    }));
  }

  handleAddPlayer = (name) => {
   this.setState( prevState => {
      return {
      players: [
         ...prevState.players,
         {
            name: name,
            score: 0,
            id: this.prevPlayerID += 1,
            isHighScore: false
         }
      ]
      }  
   });
  }

  handleRemovePlayer = (id) => {
    this.setState( prevState => {
      return {
        players: prevState.players.filter(p => p.id !== id)
      };
    });
  }

  getHighScore = () => {
     const scores = this.state.players.map(p => p.score);
     const highScore = Math.max(...scores);
     if (highScore) {
        return highScore;
     }
     return null;
  }

  render() {
     const highScore = this.getHighScore();
    return (
      <div className="scoreboard">
        <Header 
          title="Scoreboard" 
          players={this.state.players} 
        />
  
        {/* Players list */}
        {this.state.players.map( (player, index) =>
          <Player 
            name={player.name}
            score={player.score}
            id={player.id}
            key={player.id.toString()}
            index={index}
            changeScore={this.handleScoreChange} 
            removePlayer={this.handleRemovePlayer}
            isHighScore={highScore === player.score}           
          />
        )}
        <AddPlayerForm addPlayer={this.handleAddPlayer}/>
      </div>
    );
  }
}

export default App;
